/**
 * Metadata catalog of the badges granted by the SERVER v1 (F3-C). The id
 * (badge_award.badge_id) is the stable key; the UI resolves title/description/
 * emoji from here (the texts are translated in the web layer with `msg`).
 */

export interface BadgeMeta {
  id: string;
  /** Stable i18n key (the web maps it to `msg`). */
  titleKey: string;
  descriptionKey: string;
  /** Emoji from the gamification kit (lightweight, theme-agnostic visual). */
  emoji: string;
}

export const BADGE_FIRST_ENROLLMENT = "first_enrollment";
export const BADGE_FORUM_FIRST_POST = "forum_first_post";
export const BADGE_STREAK_7 = "streak_7";

export const BADGE_CATALOG: Record<string, BadgeMeta> = {
  [BADGE_FIRST_ENROLLMENT]: {
    id: BADGE_FIRST_ENROLLMENT,
    titleKey: "badge.first_enrollment.title",
    descriptionKey: "badge.first_enrollment.description",
    emoji: "🎓",
  },
  [BADGE_FORUM_FIRST_POST]: {
    id: BADGE_FORUM_FIRST_POST,
    titleKey: "badge.forum_first_post.title",
    descriptionKey: "badge.forum_first_post.description",
    emoji: "💬",
  },
  [BADGE_STREAK_7]: {
    id: BADGE_STREAK_7,
    titleKey: "badge.streak_7.title",
    descriptionKey: "badge.streak_7.description",
    emoji: "🔥",
  },
};

/** Metadata of a badge (generic fallback if the id is unknown). */
export function badgeMeta(badgeId: string): BadgeMeta {
  return (
    BADGE_CATALOG[badgeId] ?? {
      id: badgeId,
      titleKey: "badge.unknown.title",
      descriptionKey: "badge.unknown.description",
      emoji: "🏅",
    }
  );
}
